/* Bellascena — interne links in redactionele tekst binnen de markt houden.
 *
 * De teksten van pagina's, beleidsstukken en productomschrijvingen worden in
 * Shopify geschreven, niet in het theme. Daar staan links in als
 * "https://bellascena.com/pages/contact" of "/pages/contact", zonder de
 * markt-prefix. Klikt een Nederlandse of Poolse klant daarop, dan valt hij
 * terug naar de standaardmarkt en staat de winkel ineens in het Engels.
 *
 * Liquid kan daar niet bij: het is rich text die als één blok wordt
 * uitgeschreven. Vandaar deze correctie in de browser, en alleen daar waar het
 * om redactionele tekst gaat — .rte en de beleidsteksten. De rest van het
 * theme zet zijn adressen al goed neer via bellascena-url.liquid.
 *
 * Wat we met rust laten: externe domeinen, ankers, mailto en tel, en alles wat
 * de prefix al heeft.
 */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root === '/') return; // standaardmarkt: er valt niets te prefixen

  var basis = root.replace(/\/$/, ''); // "/nl-nl"
  var eigenHost = window.location.host;

  function herstel(a) {
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return;

    var pad = null;
    if (href.indexOf('//') === 0) {
      return; // protocol-relatief, meestal een cdn
    } else if (href.charAt(0) === '/') {
      pad = href;
    } else if (/^https?:\/\//i.test(href)) {
      var u;
      try { u = new URL(href); } catch (e) { return; }
      if (u.host !== eigenHost) return; // extern
      pad = u.pathname + u.search + u.hash;
    } else {
      return; // relatief zonder slash: laten staan
    }

    if (pad === basis || pad.indexOf(basis + '/') === 0) return; // heeft de prefix al
    a.setAttribute('href', basis + pad);
  }

  // Shopify's eigen cookiebanner linkt naar het privacybeleid zonder de markt:
  // op de Nederlandse winkel wordt dat /nl/policies/privacy-policy (alleen de
  // taal) en op de Britse /policies/privacy-policy (helemaal niets). Beide
  // bestaan hier niet als markt-pad, dus je belandt op een lege pagina in het
  // Engels met dollars.
  //
  // Daarom zetten we de prefix er ook buiten .rte op — maar uitsluitend op
  // gewone winkelpaden. Inlog- en checkout-adressen van Shopify blijven met
  // rust: die regelen hun eigen taal via een parameter en raken stuk als je er
  // een prefix voor plakt.
  var taal = (document.documentElement.lang || '').split('-')[0];
  var winkelpaden = ['/policies/', '/pages/', '/collections/', '/products/', '/blogs/',
                     '/cart', '/search', '/account'];

  function isWinkelpad(pad) {
    for (var i = 0; i < winkelpaden.length; i++) {
      if (pad.indexOf(winkelpaden[i]) === 0) return true;
    }
    return false;
  }

  function herstelMarkt(a) {
    var href = a.getAttribute('href') || '';
    var pad = null;
    if (href.charAt(0) === '/' && href.charAt(1) !== '/') {
      pad = href;
    } else if (/^https?:\/\//i.test(href)) {
      var u;
      try { u = new URL(href); } catch (e) { return; }
      if (u.host !== eigenHost) return;
      pad = u.pathname + u.search + u.hash;
    } else {
      return;
    }
    if (pad.indexOf(basis + '/') === 0) return; // heeft de markt al

    // /nl/policies/... — alleen de taalcode ervoor
    if (taal && pad.indexOf('/' + taal + '/') === 0) {
      var rest = pad.slice(taal.length + 1);
      if (isWinkelpad(rest)) a.setAttribute('href', basis + rest);
      return;
    }
    // /policies/... — helemaal geen prefix
    if (isWinkelpad(pad)) a.setAttribute('href', basis + pad);
  }

  function loop() {
    document
      .querySelectorAll('.rte a[href], .shopify-policy__body a[href]')
      .forEach(herstel);
    document.querySelectorAll('a[href]').forEach(herstelMarkt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loop);
  } else {
    loop();
  }

  // De cookiebanner komt later binnen dan de pagina, dus één keer kijken is niet
  // genoeg. Een teller op het aantal wijzigingen werkt hier niet: bij het laden
  // zijn er in een oogwenk honderden, en dan is de observer al weg voordat de
  // banner er is. Daarom een vast venster van vijftien seconden, met een korte
  // ontdubbeling zodat we niet bij elke wijziging de hele pagina aflopen.
  if (window.MutationObserver) {
    var wacht = null;
    var kijker = new MutationObserver(function () {
      if (wacht) return;
      wacht = setTimeout(function () { wacht = null; loop(); }, 120);
    });
    kijker.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      kijker.disconnect();
      if (wacht) { clearTimeout(wacht); wacht = null; }
      loop();
    }, 15000);
  }
})();
